var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPracticsl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 930.724,
    height: 613.071,
    viewBox: "0 0 930.724 613.071",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(-125.881 -143.464)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 108.283,
    cy: 108.283,
    rx: 108.283,
    ry: 108.283,
    transform: "translate(192.114 538.103)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 108.283,
    cy: 108.283,
    rx: 108.283,
    ry: 108.283,
    transform: "translate(383.434 151.324)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280-660",
    "data-name": "Path 280",
    d: "M682.043,800.953,295.265,414.175H682.641v1.691H299.349l383.89,383.89Z",
    transform: "translate(-120.843 -46.11)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 436.515,
    height: 1.692,
    transform: "translate(125.881 754.844)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(596.399 143.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314-661",
    "data-name": "Path 314",
    d: "M430.65,638.795a16.859,16.859,0,0,0-14.045-21.7L336.046,522.96l-18.789,19.728L397.5,632.944a16.95,16.95,0,0,0,33.152,5.851Z",
    transform: "translate(-146.253 -366.518)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315-662",
    "data-name": "Path 315",
    d: "M423.682,546.42a7.054,7.054,0,0,0-2.009-5.526l-24.888-25.236a19.612,19.612,0,1,0-31.736,23.052L381.6,570.183a7.062,7.062,0,0,0,10.417,2.415l28.8-21.046A7.054,7.054,0,0,0,423.682,546.42Z",
    transform: "translate(-207.681 -375.28)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 38.544,
    cy: 38.544,
    rx: 38.544,
    ry: 38.544,
    transform: "translate(119.018 36.293)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316-663",
    "data-name": "Path 316",
    d: "M454.309,625.093a6.981,6.981,0,0,0,2.771-4.809A616.739,616.739,0,0,1,468.7,554.043a41.576,41.576,0,0,0-77.205-28.853c-15.158,28.449-16.316,67.507-16.111,82.979a7.049,7.049,0,0,0,5.89,6.854l67.63,11.384a7.138,7.138,0,0,0,1.193.1,7,7,0,0,0,4.215-1.413Z",
    transform: "translate(-275.789 -377.774)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317-664",
    "data-name": "Path 317",
    d: "M445.983,505.509a16.522,16.522,0,0,1,.375,2.574l67.414,38.891,16.386-9.433,17.468,22.869-27.385,19.518a12.555,12.555,0,0,1-15.063-.367L435.664,524.72a16.473,16.473,0,1,1,10.319-19.211Z",
    transform: "translate(-413.471 -383.691)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318-665",
    "data-name": "Path 318",
    d: "M393.839,540.064,415.627,568.3a7.062,7.062,0,0,0,10.677.585l24.666-25.613a19.612,19.612,0,1,0-24.052-30.985l-30.936,17.3a7.062,7.062,0,0,0-2.143,10.477Z",
    transform: "translate(-291.284 -374.939)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319-666",
    "data-name": "Path 319",
    d: "M339.019,743.364l-19.24,0-4.529-73.97,23.772-.239Z",
    transform: "translate(-270.431 -148.943)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320-667",
    "data-name": "Path 320",
    d: "M514.162,798.046l-37.889,0h0a24.146,24.146,0,0,0-24.146,24.147v.784l62.036,0Z",
    transform: "translate(-440.667 -209.907)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-668",
    "data-name": "Path 321",
    d: "M226.642,743.365l-19.24,0-9.152-74.21,28.4,0Z",
    transform: "translate(25.557 -148.944)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322-669",
    "data-name": "Path 322",
    d: "M397.162,798.046l-37.889,0h0a24.146,24.146,0,0,0-24.146,24.147v.784l62.036,0Z",
    transform: "translate(-140.056 -209.907)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323-670",
    "data-name": "Path 323",
    d: "M524.824,895.713,548.7,892.6a7.061,7.061,0,0,0,5.906-8.834L519.778,712.613a397.865,397.865,0,0,1-7.172-50.358c-1.017-13.768-5.047-33.238-18.474-47.8A201.88,201.88,0,0,1,478.87,595.6l-10.543-14.6L398.1,569.832l-.048.869a406.986,406.986,0,0,1-42.583,160.35,181.1,181.1,0,0,0-18.994,72.144l-3.98,77.606a7.072,7.072,0,0,0,2.045,5.339,6.981,6.981,0,0,0,5.329,2.075l22.826-1.038a7.074,7.074,0,0,0,6.57-5.509l19.058-85.025a5.55,5.55,0,0,1,.965-2.1l59.808-79.743a3.924,3.924,0,0,1,6.842,1.058l61.313,175.178a7.1,7.1,0,0,0,6.674,4.729,6.927,6.927,0,0,0,.9-.058Z",
    transform: "translate(-293.594 -339.833)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324-671",
    "data-name": "Path 324",
    d: "M300.113,471.357a170.952,170.952,0,0,1-6.755-28.476c-.451-5.628.991-11.685,5.09-15.568,7.671-7.268,20.7-3.806,28.726,3.072,11.594,9.94,17.376,25.217,19.561,40.332s1.224,30.485,1.75,45.747,2.709,30.956,10.49,44.1,22.221,23.228,37.451,22.109a26.357,26.357,0,0,0,16.5-6.992,19.131,19.131,0,0,0,5.746-16.613c7.785,13.939,3.838,32.832-7.773,43.79s-29.472,14.056-44.737,9.377-27.828-16.41-35.333-30.5-10.254-30.371-9.856-46.332c.306-12.257,2.39-24.614.318-36.7s-9.634-24.354-21.56-27.2Z",
    transform: "translate(-99.931 -423.272)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325-672",
    "data-name": "Path 325",
    d: "M399.8,480.019c-2.033,6.792-9.811,10.981-16.807,9.832s-12.749-6.91-14.875-13.674a28.151,28.151,0,0,1,2.2-20.637A32.137,32.137,0,0,1,388.7,439.16a26.387,26.387,0,0,1,23.993,3.834,8.824,8.824,0,0,1,6.166-6.449,16.861,16.861,0,0,1,9.254.137,38.128,38.128,0,0,1,21.221,15.438,62.042,62.042,0,0,1,9.618,24.792c2.368,13.29,1.494,27.812-5.97,39.06S430.25,533.862,417.862,528.5c-.773-3.949,1.057-7.926,3.175-11.347s4.626-6.755,5.44-10.7-.746-8.761-4.558-10.05c-3.252-1.1-6.719.682-10.145.9a11.117,11.117,0,0,1-10.664-16.019Z",
    transform: "translate(-253.17 -416.046)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 137.428,
    height: 1.644,
    transform: "translate(919.177 754.891)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292-673",
    "data-name": "Path 292",
    d: "M1024.205,669.172c-14.478,23.637-9.5,53.038-9.5,53.038s28.455-8.921,42.933-32.558,9.5-53.038,9.5-53.038S1038.683,645.536,1024.205,669.172Z",
    transform: "translate(-24.957 32.76)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293-674",
    "data-name": "Path 293",
    d: "M995.35,722.8l-.8-.249c-.288-.09-28.882-9.275-43.336-32.871s-9.644-53.243-9.594-53.54l.139-.822.8.249c.288.09,28.882,9.275,43.336,32.872h0c14.453,23.6,9.644,53.242,9.594,53.539Zm-52.413-85.568c-.658,4.976-3.282,30.784,9.522,51.688s36.987,30.291,41.718,31.966c.658-4.976,3.282-30.784-9.522-51.687h0c-12.8-20.9-36.987-30.292-41.718-31.967Z",
    transform: "translate(-5.021 33.114)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 15.997,
    cy: 15.997,
    rx: 15.997,
    ry: 15.997,
    transform: "translate(974.658 646.385)",
    fill: "#ccc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPracticsl);
export default __webpack_public_path__ + "static/media/practicsl.c17ab6bf7bf9fd2a13eee16a3e4a4122.svg";
export { ForwardRef as ReactComponent };